import React from 'react';
import { SignUp } from '@clerk/clerk-react';

export default function SignUpPage() {
  // Detect user's timezone from browser
  const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  
  return (
    <div style={{ 
      display: 'flex', 
      justifyContent: 'center', 
      alignItems: 'center', 
      height: '100vh' 
    }}>
      <SignUp 
        routing="path" 
        path="/sign-up"
        signInUrl="/sign-in"
        unsafeMetadata={{
          timezone: userTimezone
        }}
      />
    </div>
  );
}